<template>
  <div id="container">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'base'
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/base.vue